import FileSaver from "file-saver";
import md5 from "md5";

export function WriteFileExcel(data: any[], id: string, instruction?: boolean) {
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const csvData =
    data.length > 0
      ? data.map((x: any) => {
          return {
            "Supplier's Product Code": x.content.supplier_code,
            "Offer Price (USD)": x.content.saleprice,
            "Category ID": x.content.itemcategory,
            "Brand ID": x.content.brand_id,
            Title: typeof x.content.title === "object" ? x.content.title.en : x.content.title,
            "Title Khmer": typeof x.content.title === "object" ? x.content.title.km : "",
            "Title Chinese": typeof x.content.title === "object" ? x.content.title.zh : "",
            Description: typeof x.content.description === "object" ? x.content.description.en : x.content.description,
            "Description Khmer": typeof x.content.description === "object" ? x.content.description.km : "",
            "Description Chinese": typeof x.content.description === "object" ? x.content.description.zh : "",
            "Attribute1 (Colors)": x.content.colours,
            "Attribute2 (Sizes)": x.content.size,
            Weight: x.content.weight,
            Dimension: x.content.dimension_width + "," + x.content.dimension_height + "," + x.content.dimension_length,
            "Remote Stock": x.content.remote_stock === "F" ? "no" : "yes",
            Consumable: x.content.consumable === "F" ? "no" : "yes",
            "Main Image Address": x.content.picture + "||" + x.content.color_binding,
            "Additional Image Addresses 1": x.content.images[0].src + "||" + x.content.images[0].color,
            "Additional Image Addresses 2": x.content.images[1]
              ? x.content.images[1].src + "||" + x.content.images[1].color
              : "",
            "Additional Image Addresses 3": x.content.images[2]
              ? x.content.images[2].src + "||" + x.content.images[2].color
              : "",
            "Additional Image Addresses 4": x.content.images[3]
              ? x.content.images[3].src + "||" + x.content.images[3].color
              : "",
            "Additional Image Addresses 5": x.content.images[4]
              ? x.content.images[4].src + "||" + x.content.images[4].color
              : "",
            "Additional Image Addresses 6": x.content.images[5]
              ? x.content.images[5].src + "||" + x.content.images[5].color
              : "",
            "Additional Image Addresses 7": x.content.images[6]
              ? x.content.images[6].src + "||" + x.content.images[6].color
              : "",
            "Additional Image Addresses 8": x.content.images[7]
              ? x.content.images[7].src + "||" + x.content.images[7].color
              : "",
            "Additional Image Addresses 9": x.content.images[8]
              ? x.content.images[8].src + "||" + x.content.images[8].color
              : "",
            "Additional Image Addresses 10": x.content.images[9]
              ? x.content.images[9].src + "||" + x.content.images[9].color
              : "",
          };
        })
      : [
          {
            "Supplier's Product Code": "",
            "Offer Price (USD)": "",
            "Category ID": "",
            "Brand ID": "",
            Title: "",
            "Title Khmer": "",
            "Title Chinese": "",
            Description: "",
            "Description Khmer": "",
            "Description Chinese": "",
            "Attribute1 (Colors)": "",
            "Attribute2 (Sizes)": "",
            Weight: "",
            Dimension: "",
            "Remote Stock": "",
            Consumable: "",
            "Main Image Address": "",
            "Additional Image Addresses 1": "",
            "Additional Image Addresses 2": "",
            "Additional Image Addresses 3": "",
            "Additional Image Addresses 4": "",
            "Additional Image Addresses 5": "",
            "Additional Image Addresses 6": "",
            "Additional Image Addresses 7": "",
            "Additional Image Addresses 8": "",
            "Additional Image Addresses 9": "",
            "Additional Image Addresses 10": "",
          },
        ];

  const dummy = [
    {
      "Supplier's Product Code": "Code of a specific product Supplier Product Code should be unique within the store",
      "Offer Price (USD)": "Sale price listed on L192",
      "Category ID": "Category ID You can get it in the upload panel",
      "Brand ID": "Brand ID listed in the upload panel leave empty if it doesn't have a brand",
      Title: "Several words english to describe the item",
      "Title Khmer": "Several words khmer to describe the item",
      "Title Chinese": "Several words chinese to describe the item",
      Description: "Describe your product here.",
      "Description Khmer": "Describe your product here.",
      "Description Chinese": "Describe your product here.",
      "Attribute1 (Colors)": "Available colors separated by comma(,)",
      "Attribute2 (Sizes)": "Available sizes separated by comma(,)",
      Weight: "Product Weight in gram",
      Dimension:
        "Product Dimension in cm separated by comma(,) must have 3 parts representing all 3 sides of the package",
      "Remote Stock": "Is the product remote stock?",
      Consumable: "Is the product consumable?",
      "Main Image Address": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 1": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 2": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 3": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 4": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 5": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 6": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 7": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 8": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 9": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 10": `format: image's address || color
        
            eg. https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black
            
            https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
    },
    {
      "Supplier's Product Code": "1234",
      "Offer Price (USD)": "10",
      "Category ID": "344",
      "Brand ID": "1",
      Title: "5.11 cotton v-neck t-shirt",
      "Title Khmer": "អាវយឺត 5.11 កប្បាស",
      "Title Chinese": "5.11純棉V領T卹",
      Description: "5.11 cotton v-neck t-shirt",
      "Description Khmer": "អាវយឺត 5.11 កប្បាស",
      "Description Chinese": "5.11純棉V領T卹",
      "Attribute1 (Colors)": "Black, White",
      "Attribute2 (Sizes)": "S,M,L",
      Weight: "1000",
      Dimension: "25,30,50",
      "Remote Stock": "yes",
      Consumable: "yes",
      "Main Image Address":
        "https://ichef.bbci.co.uk/live-experience/cps/624/cpsprodpb/vivo/live/images/2020/5/26/1bd410f5-8541-461e-bef9-b7cfe8b23b0d.jpg||black",
      "Additional Image Addresses 2":
        "https://ichef.bbci.co.uk/live-experience/cps/624/cpsprodpb/vivo/live/images/2020/5/26/1bd410f5-8541-461e-bef9-b7cfe8b23b0d.jpg||red",
      "Additional Image Addresses 3": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black`,
      "Additional Image Addresses 4": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 5": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 6": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 7": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 8": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 9": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 10": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
    },
    {
      "Supplier's Product Code": "2345",
      "Offer Price (USD)": "15",
      "Category ID": "344",
      "Brand ID": "1",
      Title: "5.11 cotton v-neck t-shirt",
      "Title Khmer": "អាវយឺត 5.11 កប្បាស",
      "Title Chinese": "5.11純棉V領T卹",
      Description: "5.11 cotton v-neck t-shirt",
      "Description Khmer": "អាវយឺត 5.11 កប្បាស",
      "Description Chinese": "5.11純棉V領T卹",
      "Attribute1 (Colors)": "Black, White",
      "Attribute2 (Sizes)": "S,M,L",
      Weight: "1000",
      Dimension: "25,30,50",
      "Remote Stock": "no",
      Consumable: "no",
      "Main Image Address":
        "https://ichef.bbci.co.uk/live-experience/cps/624/cpsprodpb/vivo/live/images/2020/5/26/1bd410f5-8541-461e-bef9-b7cfe8b23b0d.jpg||black",
      "Additional Image Addresses 2":
        "https://ichef.bbci.co.uk/live-experience/cps/624/cpsprodpb/vivo/live/images/2020/5/26/1bd410f5-8541-461e-bef9-b7cfe8b23b0d.jpg||red",
      "Additional Image Addresses 3": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||black`,
      "Additional Image Addresses 4": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 5": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 6": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 7": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 8": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 9": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
      "Additional Image Addresses 10": `https://s5.kh1.co/64/6475871ca2cd914f7428798787540f4742ebc6f6.jpg||red`,
    },
  ];

  import("xlsx").then((xlsx) => {
    const ws = xlsx.utils.json_to_sheet(csvData);
    const wsdummy = xlsx.utils.json_to_sheet(instruction ? dummy : []);
    const wb = {
      Sheets: { data: ws, instruction: wsdummy },
      SheetNames: instruction ? ["data", "instruction"] : ["data"],
    };
    const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
    const val = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(val, md5(id + new Date()) + fileExtension);
  });
}
